var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#admon_svg__clip0_518_2471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20zm-18.944-1.678c1.945.585 6.444 1.939 6.444 6.056 0 3.005-2.18 5.089-5.688 5.538v1.82c0 .421-.41.764-.915.764h-2.37c-.505 0-.916-.342-.916-.764v-1.978c-2.02-.475-3.727-1.45-4.707-2.11-.505-.343-.536-.95-.095-1.345l1.643-1.398a1.274 1.274 0 011.453-.079c1.013.659 2.655 1.502 4.14 1.502 2.938 0 2.938-1.423 2.938-1.95 0-.845-.253-1.582-3.475-2.532-4.58-1.346-6.887-3.481-6.887-6.33 0-2.584 1.958-4.562 4.992-5.301V8.264c0-.421.41-.764.915-.764h2.37c.505 0 .915.342.915.764v1.767c1.706.29 3.095.95 3.98 1.478.537.315.6.975.16 1.37l-1.58 1.423c-.348.344-.949.396-1.39.16-.728-.396-1.803-.818-2.876-.792-.695.027-2.969.185-2.969 1.846 0 .502 0 1.636 3.886 2.796l.032.01z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "admon_svg__clip0_518_2471"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
export default SvgAdmon;